import { NavLink, Outlet, useNavigate } from "react-router-dom";
import { ChartBar, Users as UsersIcon, ListChecks, SignOut, Trophy, ChartLineUp } from "@phosphor-icons/react";
import { useAuth } from "@/context/AuthContext";

const roleLabel = { admin: "Administrator", agent: "Agent", writer: "Writer" };

export default function Layout() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const nav = [
    { to: "/", label: "Overview", icon: ChartBar, end: true },
    { to: "/leads", label: "Leads", icon: ListChecks },
  ];
  if (user?.role === "admin") {
    nav.push({ to: "/leaderboard", label: "Leaderboard", icon: Trophy });
    nav.push({ to: "/reports", label: "Reports", icon: ChartLineUp });
    nav.push({ to: "/users", label: "Team", icon: UsersIcon });
  }

  return (
    <div className="min-h-screen grid grid-cols-1 md:grid-cols-[240px_1fr] bg-[#F7F7F5]">
      <aside className="border-r border-[#111] bg-white flex flex-col md:min-h-screen">
        <div className="p-6 border-b border-[#111]">
          <p className="font-mono text-[10px] tracking-widest text-[#0047FF]">MHA WRITERS</p>
          <h1 className="font-heading text-2xl font-bold tracking-tighter">CRM Console</h1>
        </div>
        <nav className="flex-1 p-3 space-y-1">
          {nav.map((n) => (
            <NavLink
              key={n.to}
              to={n.to}
              end={n.end}
              data-testid={`nav-${n.label.toLowerCase()}`}
              className={({ isActive }) =>
                `flex items-center gap-3 px-3 py-2.5 text-sm font-medium transition-colors ${
                  isActive ? "bg-[#0047FF] text-white" : "text-[#333] hover:bg-[#f0f0ee]"
                }`
              }
            >
              <n.icon size={18} weight="bold" />
              {n.label}
            </NavLink>
          ))}
        </nav>
        <div className="p-3 border-t border-[#111]">
          <div className="px-3 py-2 mb-2">
            <p className="text-sm font-semibold truncate">{user?.name}</p>
            <p className="font-mono text-[10px] uppercase tracking-wide text-[#0047FF]">{roleLabel[user?.role]}</p>
          </div>
          <button
            onClick={() => { logout(); navigate("/login"); }}
            data-testid="logout-button"
            className="w-full flex items-center gap-3 px-3 py-2.5 text-sm font-medium text-[#333] hover:bg-[#f0f0ee] transition-colors"
          >
            <SignOut size={18} weight="bold" /> Sign out
          </button>
        </div>
      </aside>

      <main className="overflow-x-hidden">
        <Outlet />
      </main>
    </div>
  );
}
